module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('group', {
    attrs: {
      "title": "基本信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "真实姓名",
      "value": _vm.info.true_name ? _vm.info.true_name : '长度不超过10个汉字'
    },
    nativeOn: {
      "click": function($event) {
        _vm.edit('trueName')
      }
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "手机号",
      "value": _vm.info.mobile > 0 ? _vm.info.mobile : '未设置',
      "link": "/uc/mobile",
      "is-link": ""
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "微信号",
      "value": _vm.info.wechat ? _vm.info.wechat : '请设置',
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.edit('wechat')
      }
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "其他信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "收货地址",
      "value": "设置",
      "link": "/uc/address",
      "is-link": ""
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "银行卡号",
      "value": "设置",
      "link": "/uc/bankcard",
      "is-link": ""
    }
  })], 1), _vm._v(" "), _c('confirm', {
    ref: "confirm1",
    attrs: {
      "show-input": "",
      "title": "输入内容",
      "theme": "android"
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-confirm": _vm.onConfirm,
      "on-show": _vm.onShow,
      "on-hide": _vm.onHide
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47413eca"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/Setting.vue
// module id = 678
// module chunks = 0